import { render } from "./Subtickets.vue?vue&type=template&id=0b2ab792"
import script from "./Subtickets.vue?vue&type=script&lang=js"
export * from "./Subtickets.vue?vue&type=script&lang=js"

import "./Subtickets.vue?vue&type=style&index=0&id=0b2ab792&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__